var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _rect, _path19, _rect2, _path20, _rect3, _path21, _rect4, _path22, _rect5, _path23, _rect6, _rect7, _rect8, _path24, _g, _g2, _g3, _g4, _g5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimeline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: "64px",
    height: "64px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff8ee",
    d: "M58,56H6c-1.105,0-2-0.895-2-2V18c0-3.314,2.686-6,6-6h44c3.3,0,6,2.7,6,6v36 C60,55.105,59.105,56,58,56z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#f283a5",
    d: "M59.024,22H4.976C4.437,22,4,21.563,4,21.024V18c0-3.314,2.686-6,6-6h44c3.314,0,6,2.686,6,6v3.024 C60,21.563,59.563,22,59.024,22z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#8d6c9f",
    d: "M58,57H6c-1.654,0-3-1.346-3-3V18c0-3.859,3.141-7,7-7h44c3.859,0,7,3.141,7,7v36 C61,55.654,59.654,57,58,57z M10,13c-2.757,0-5,2.243-5,5v36c0,0.552,0.448,1,1,1h52c0.552,0,1-0.448,1-1V18c0-2.757-2.243-5-5-5 H10z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#8d6c9f",
    d: "M30,17c-0.553,0-1-0.447-1-1v-6c0-0.552-0.448-1-1-1s-1,0.448-1,1v2c0,0.553-0.447,1-1,1 s-1-0.447-1-1v-2c0-1.654,1.346-3,3-3s3,1.346,3,3v6C31,16.553,30.553,17,30,17z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#8d6c9f",
    d: "M38,17c-0.553,0-1-0.447-1-1v-6c0-0.552-0.448-1-1-1s-1,0.448-1,1v2c0,0.553-0.447,1-1,1 s-1-0.447-1-1v-2c0-1.654,1.346-3,3-3s3,1.346,3,3v6C39,16.553,38.553,17,38,17z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#8d6c9f",
    d: "M14,17c-0.553,0-1-0.447-1-1v-6c0-0.552-0.448-1-1-1s-1,0.448-1,1v2c0,0.553-0.447,1-1,1 s-1-0.447-1-1v-2c0-1.654,1.346-3,3-3s3,1.346,3,3v6C15,16.553,14.553,17,14,17z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#8d6c9f",
    d: "M22,17c-0.553,0-1-0.447-1-1v-6c0-0.552-0.448-1-1-1s-1,0.448-1,1v2c0,0.553-0.447,1-1,1 s-1-0.447-1-1v-2c0-1.654,1.346-3,3-3s3,1.346,3,3v6C23,16.553,22.553,17,22,17z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#8d6c9f",
    d: "M46,17c-0.553,0-1-0.447-1-1v-6c0-0.552-0.448-1-1-1s-1,0.448-1,1v2c0,0.553-0.447,1-1,1 s-1-0.447-1-1v-2c0-1.654,1.346-3,3-3s3,1.346,3,3v6C47,16.553,46.553,17,46,17z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#8d6c9f",
    d: "M54,17c-0.553,0-1-0.447-1-1v-6c0-0.552-0.448-1-1-1s-1,0.448-1,1v2c0,0.553-0.447,1-1,1 s-1-0.447-1-1v-2c0-1.654,1.346-3,3-3s3,1.346,3,3v6C55,16.553,54.553,17,54,17z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#8d6c9f",
    d: "M60,23H4c-0.553,0-1-0.447-1-1s0.447-1,1-1h56c0.553,0,1,0.447,1,1S60.553,23,60,23z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#8d6c9f",
    d: "M60,29H4c-0.553,0-1-0.447-1-1s0.447-1,1-1h56c0.553,0,1,0.447,1,1S60.553,29,60,29z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#8d6c9f",
    d: "M33.993,35c-0.554,0-1.001,0.447-1.001,1v2c0,0.553,0.448,1,1.001,1s1.001-0.447,1.001-1v-2 C34.994,35.448,34.547,35,33.993,35z M39,35c-0.554,0-1.001,0.447-1.001,1v2c0,0.553,0.448,1,1.001,1c0.554,0,1.001-0.447,1.001-1 v-2C40.001,35.448,39.554,35,39,35z M44.007,35c-0.554,0-1.001,0.447-1.001,1v2c0,0.553,0.448,1,1.001,1 c0.554,0,1.001-0.447,1.001-1v-2C45.009,35.448,44.561,35,44.007,35z M49.014,35c-0.554,0-1.001,0.447-1.001,1v2 c0,0.553,0.448,1,1.001,1c0.554,0,1.001-0.447,1.001-1v-2C50.016,35.448,49.568,35,49.014,35z M53.999,35 c-0.554,0-1.001,0.447-1.001,1v2c0,0.553,0.448,1,1.001,1S55,38.553,55,38v-2C55,35.448,54.552,35,53.999,35z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#8d6c9f",
    d: "M12,29c-0.553,0-1-0.447-1-1v-6c0-0.553,0.447-1,1-1s1,0.447,1,1v6C13,28.553,12.553,29,12,29z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#8d6c9f",
    d: "M20,29c-0.553,0-1-0.447-1-1v-6c0-0.553,0.447-1,1-1s1,0.447,1,1v6C21,28.553,20.553,29,20,29z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#8d6c9f",
    d: "M28,29c-0.553,0-1-0.447-1-1v-6c0-0.553,0.447-1,1-1s1,0.447,1,1v6C29,28.553,28.553,29,28,29z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#8d6c9f",
    d: "M36,29c-0.553,0-1-0.447-1-1v-6c0-0.553,0.447-1,1-1s1,0.447,1,1v6C37,28.553,36.553,29,36,29z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#8d6c9f",
    d: "M44,29c-0.553,0-1-0.447-1-1v-6c0-0.553,0.447-1,1-1s1,0.447,1,1v6C45,28.553,44.553,29,44,29z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#8d6c9f",
    d: "M52,29c-0.553,0-1-0.447-1-1v-6c0-0.553,0.447-1,1-1s1,0.447,1,1v6C53,28.553,52.553,29,52,29z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 6,
    x: 4,
    y: 22,
    fill: "#f9e3ae"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#8d6c9f",
    d: "M12,29H4c-0.553,0-1-0.447-1-1v-6c0-0.553,0.447-1,1-1h8c0.553,0,1,0.447,1,1v6 C13,28.553,12.553,29,12,29z M5,27h6v-4H5V27z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 6,
    x: 12,
    y: 22,
    fill: "#f9dd8f"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#8d6c9f",
    d: "M20,29h-8c-0.553,0-1-0.447-1-1v-6c0-0.553,0.447-1,1-1h8c0.553,0,1,0.447,1,1v6 C21,28.553,20.553,29,20,29z M13,27h6v-4h-6V27z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 6,
    x: 20,
    y: 22,
    fill: "#f9e3ae"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#8d6c9f",
    d: "M28,29h-8c-0.553,0-1-0.447-1-1v-6c0-0.553,0.447-1,1-1h8c0.553,0,1,0.447,1,1v6 C29,28.553,28.553,29,28,29z M21,27h6v-4h-6V27z"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 6,
    x: 28,
    y: 22,
    fill: "#f9dd8f"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#8d6c9f",
    d: "M36,29h-8c-0.553,0-1-0.447-1-1v-6c0-0.553,0.447-1,1-1h8c0.553,0,1,0.447,1,1v6 C37,28.553,36.553,29,36,29z M29,27h6v-4h-6V27z"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 6,
    x: 36,
    y: 22,
    fill: "#f9e3ae"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#8d6c9f",
    d: "M44,29h-8c-0.553,0-1-0.447-1-1v-6c0-0.553,0.447-1,1-1h8c0.553,0,1,0.447,1,1v6 C45,28.553,44.553,29,44,29z M37,27h6v-4h-6V27z"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 4,
    x: 4,
    y: 35,
    fill: "#b0edcc"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 4,
    x: 36,
    y: 45,
    fill: "#85cbf8"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 6,
    x: 44,
    y: 22,
    fill: "#f9dd8f"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#8d6c9f",
    d: "M52,29h-8c-0.553,0-1-0.447-1-1v-6c0-0.553,0.447-1,1-1h8c0.553,0,1,0.447,1,1v6 C53,28.553,52.553,29,52,29z M45,27h6v-4h-6V27z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 6,
    x: 52,
    y: 22,
    fill: "#f9e3ae"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8d6c9f",
    d: "M60,29h-8c-0.553,0-1-0.447-1-1v-6c0-0.553,0.447-1,1-1h8c0.553,0,1,0.447,1,1v6 C61,28.553,60.553,29,60,29z M53,27h6v-4h-6V27z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#8d6c9f",
    d: "M28,40H4c-0.553,0-1-0.447-1-1v-4c0-0.553,0.447-1,1-1h24c0.553,0,1,0.447,1,1v4 C29,39.553,28.553,40,28,40z M5,38h22v-2H5V38z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#8d6c9f",
    d: "M60,50H36c-0.553,0-1-0.447-1-1v-4c0-0.553,0.447-1,1-1h24c0.553,0,1,0.447,1,1v4 C61,49.553,60.553,50,60,50z M37,48h22v-2H37V48z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#8d6c9f",
    d: "M23,48H10c-0.553,0-1-0.447-1-1s0.447-1,1-1h13c0.553,0,1,0.447,1,1S23.553,48,23,48z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#8d6c9f",
    d: "M30,48h-3c-0.553,0-1-0.447-1-1s0.447-1,1-1h3c0.553,0,1,0.447,1,1S30.553,48,30,48z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeline);
export default __webpack_public_path__ + "static/media/timeline.a5e06a3795ceac1f6d570b7f939c09f7.svg";
export { ForwardRef as ReactComponent };